<template>
    <div>
        <oss-dialog
            v-model="dialog"
            :minWidth="step === 'sepa' ? '1200px' : '800px'"
            title="Gestion des encours"
            :valid-title="validTitle"
            :hide-valid="step === 'chooseOperation' || step === 'paymentLink'"
            :valid-disabled="validDisabled"
            :validLoading="validLoading"
            :previousDisplay="step !== 'personalisedAmounts'"
            @valid="nextStep"
            @previous="previousStep"
            @close="close()"
            :actions="actions"
            :show="!mailerDialog"
            prefixDataCy="PaymentManagement-valid"
        >
            <v-window v-model="step">
                <v-window-item :value="'personalisedAmounts'">
                    <!-- <v-form v-model="formIsValid"> -->
                    <oss-data-table
                        :items="accountingTransactions"
                        :headers="headers"
                        :show-select="false"
                        :key="refreshKey"
                    >
                        <template v-slot:item.name="{ item }">
                            <div>
                                {{
                                    item.wording +
                                    (item.invoiceNumber ? " - " + item.invoiceNumber : "")
                                }}
                            </div>
                            <span
                                size="x-small"
                                style="color: red"
                                v-if="item.associatedPaymentLink"
                            >
                                A déjà un lien de paiement</span
                            >
                        </template>
                        <template v-slot:item.amountSigned="{ item }">
                            {{ newCommonFormatCurrency(item.amountSigned, undefined) }}
                        </template>
                        <template v-slot:body.append>
                            <tr class="x-dense">
                                <td class="text-right"><strong>Total</strong></td>
                                <td class="text-right">
                                    <div>
                                        <strong>{{
                                            newCommonFormatCurrency(total, undefined)
                                        }}</strong>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </oss-data-table>
                    <!-- </v-form> -->
                </v-window-item>
                <v-window-item :value="'chooseOperation'">
                    <v-list subheader lines="two">
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="chequePayment()"
                            v-if="containsIdenticalKey"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Remise de chèque | virement | prélèvement</v-list-item-title
                            ><v-list-item-subtitle style="white-space: normal"
                                >Les montants sélectionnés ont été réglés par chèque, virement ou
                                prélèvement mais le compte bancaire n'a pas encore été
                                débité</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="cashPayment()"
                            data-cy="PaymentManagement-especes"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Remise d'espèces</v-list-item-title
                            ><v-list-item-subtitle
                                >Les montants sélectionnés ont été réglés en
                                espèces</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="goToPayStep()"
                            v-if="total < 0 && containsIdenticalKey"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next v-if="payIsActivated" />
                            </template>
                            <v-list-item-title :style="payIsActivated ? '' : 'color:grey'">{{
                                "Payer " + (payIsActivated ? "" : "(bientôt diponible)")
                            }}</v-list-item-title
                            ><v-list-item-subtitle
                                >Payer le total des montants sélectionnés
                            </v-list-item-subtitle></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="step = 'sepa'"
                            v-if="enableSepaTransfer"
                            data-cy="PaymentManagement-virement"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Ordre de virement</v-list-item-title
                            ><v-list-item-subtitle style="white-space: normal"
                                >Préparer un ordre de virement (multi fournisseurs, employés) pour
                                executer le virement en une fois</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="step = 'sepa'"
                            v-if="enableSepaDirectDebit"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Ordre de prélèvement</v-list-item-title
                            ><v-list-item-subtitle style="white-space: normal"
                                >Préparer un ordre de prélèvement (multi clients) pour executer le
                                prélèvement en une fois</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="sendMail()"
                            v-if="enableSendMail"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>{{ mailTitle }}</v-list-item-title
                            ><v-list-item-subtitle>{{
                                mailDescription
                            }}</v-list-item-subtitle></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="goToSplitPayment()"
                            v-if="enableSplitPayment"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Découper le paiement</v-list-item-title
                            ><v-list-item-subtitle
                                >Découper le paiement pour définir plusieurs
                                règlements</v-list-item-subtitle
                            ></v-list-item
                        >
                    </v-list>
                </v-window-item>
                <v-window-item :value="'paymentLink'">
                    <v-list subheader lines="two">
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="openMailerDialogWithURL()"
                            v-if="!forCustomer"
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Intégrer un lien de paiement dans la relance</v-list-item-title
                            ><v-list-item-subtitle style="white-space: normal"
                                >Permet au destinataire de payer directement via un lien reçu avec
                                le mail de relance (il vous faudra des crédits de
                                paiement)</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="openMailerDialogWithURL()"
                            v-else
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Intégrer un lien de paiement dans la relance</v-list-item-title
                            ><v-list-item-subtitle style="white-space: normal"
                                >Permet au destinataire de payer directement via un lien reçu avec
                                le mail de relance</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click="
                                addBudgetInsightUrlForMail = false;
                                getDefaultMailer();
                            "
                        >
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Mail simple</v-list-item-title
                            ><v-list-item-subtitle
                                >Sans lien de paiement</v-list-item-subtitle
                            ></v-list-item
                        >
                    </v-list>
                </v-window-item>
                <v-window-item :value="'pay'">
                    <Pay
                        :companyId="companyId"
                        :thirdPartyCompanyId="thirdPartyCompanyId"
                        :thirdPartyUserId="thirdPartyUserId"
                        :thirdPartyName="thirdPartyName"
                        :accountableAccountName="accountableAccountName"
                        :accountingLines="actionAccountingLines"
                        :actions="payActions"
                        :fromPaymentManagementToGenerateEmail="thirdPartyType === 'CLIENT'"
                        :withoutCredits="forCustomer"
                        @getBudgetInsightOptions="mailerDialogWithBudgetInsight"
                        v-if="step === 'pay'"
                    >
                    </Pay>
                </v-window-item>
                <v-window-item :value="'cashPayment'">
                    <CashPayment
                        :userId="currentUser.id"
                        :companyId="companyId"
                        :accountingLines="actionAccountingLines"
                        :actions="cashPaymentActions"
                        @added="onActionDone($event)"
                    >
                    </CashPayment>
                </v-window-item>
                <v-window-item :value="'chequePayment'">
                    <Remittance
                        :companyId="companyId"
                        :actions="chequePaymentActions"
                        :accountableAccountName="accountableAccountName"
                        :accountingLines="actionAccountingLines"
                        @added="onActionDone($event)"
                    >
                    </Remittance>
                </v-window-item>
                <v-window-item :value="'splitPayment'">
                    <!-- <v-form v-model="formIsValid"> -->
                    <oss-data-table
                        :items="splittedPayments"
                        :headers="splitHeaders"
                        :show-select="false"
                        :footer-props="true"
                    >
                        <template v-slot:item.name="{ item }">
                            {{
                                item.wording +
                                (item.invoiceNumber ? " - " + item.invoiceNumber : "")
                            }}
                        </template>
                        <template v-slot:item.amountSigned="{ item }">
                            <!-- {{ newCommonFormatCurrency(item.amountSigned, undefined)}} -->
                            <oss-text-field-filled
                                v-model="item.amountSigned"
                                suffix="&#x20ac;"
                                dense
                                single-line
                                :hide-details="true"
                                class="pl-3"
                            />
                        </template>
                        <template v-slot:item.dueDate="{ item }">
                            <oss-date-picker-filled
                                v-model="item.dueDate"
                                hide-details
                                :textFieldReadOnly="false"
                                :notRequired="true"
                            >
                            </oss-date-picker-filled>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <!-- <td class="text-right"> -->
                            <v-btn-trash
                                @click="removeSplitPayment(item)"
                                :disabled="splittedPayments.length <= 2"
                                size="x-small"
                            />
                            <!-- </td> -->
                        </template>
                        <template v-slot:body.append>
                            <tr class="x-dense">
                                <td class="text-right">
                                    <strong>Total</strong
                                    ><strong style="color: red" v-if="total - splittedTotal">{{
                                        " (Ecart " +
                                        newCommonFormatCurrency(total - splittedTotal, undefined) +
                                        ")"
                                    }}</strong>
                                </td>
                                <!-- <td class="text-right">
                                        <div>{{newCommonFormatCurrency(totalStillOwe, undefined)}}</div>
                                    </td> -->
                                <td class="text-right">
                                    <div>
                                        <strong>{{
                                            newCommonFormatCurrency(splittedTotal, undefined)
                                        }}</strong>
                                    </div>
                                </td>
                                <td class="text-center" />
                                <td class="text-center">
                                    <VBtn
                                        size="x-small"
                                        color="primary"
                                        @click="addSplitPayment()"
                                        class="btn"
                                        elevation="0"
                                        icon="$add"
                                    >
                                    </VBtn>
                                </td>
                            </tr>
                        </template>
                    </oss-data-table>
                    <!-- </v-form> -->
                </v-window-item>
                <v-window-item :value="'sepa'">
                    <Sepa
                        :companyId="companyId"
                        :accountingLines="sepaTransactions"
                        :actions="sepaActions"
                        v-if="step === 'sepa'"
                        @onUpdated="onActionDone()"
                    >
                    </Sepa>
                </v-window-item>
                <v-window-item :value="'warnAccLinesAlreadyUsedInPaymLinks'">
                    <div>
                        Si vous allez au bout du process, les liens de paiements ci-dessous
                        expireront
                        <oss-data-table
                            :items="associatedPaymentLinks"
                            :headers="headers2"
                            :height="height"
                            :show-select="false"
                            :key="refreshKey"
                        >
                            <template v-slot:item.createdAt="{ item }">
                                {{ formatedDate(item.createdAt) }}
                            </template>
                            <template v-slot:item.amountSigned="{ item }">
                                {{ newCommonFormatCurrency(item.amountSigned, undefined) }}
                            </template>
                        </oss-data-table>
                    </div>
                </v-window-item>
            </v-window>
        </oss-dialog>
        <MailerDialog
            v-model="mailerDialog"
            :mailType="documentDefaultMailerInfos.mailType"
            :defaultSubject="documentDefaultMailerInfos.defaultSubject"
            :defaultText="documentDefaultMailerInfos.defaultText"
            :companyId="companyId"
            :thirdPartyCompanyId="thirdPartyCompanyId"
            :listDocuments="accountingTransactions"
            :withAttachment="documentDefaultMailerInfos.withAttachment"
            :budgetInsightOptions="budgetInsightOptions"
            @mailSent="onActionDone($event)"
            v-if="mailerDialog"
        />
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import { Apollo } from "@/decorators";
import moment from "moment-timezone";

import { User } from "../../store/store";

import MailerDialog from "../mail/MailerDialog.vue";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import Remittance from "../reconciliation/Remittance.vue";
import CashPayment from "../reconciliation/CashPayment.vue";
import Pay from "./Pay.vue";
import Sepa from "./Sepa.vue";
//
import { DialogAction } from "../../services/dialogAction";
import { getUserDisplayName } from "../../services/userServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import SPLIT_PAYMENT from "../../graphql/document/SplitPayment.gql";
import GET_PAYMENT_LINKS from "../../graphql/paymentLinks/GetPaymentLinks.gql";
import GET_DEFAULT_MAILER from "@/graphql/company/GetDefaultMailer.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component({
    name: "PaymentManagement",
    components: {
        MailerDialog,
        OssDataTable,
        Remittance,
        CashPayment,
        Pay,
        Sepa,
    },
    emits: ["actionDone", "sendMailFromPaymentManagement"],
})
export class PaymentManagement extends Vue {
    @Prop({ required: true }) readonly companyId: string;

    @Prop({ default: "" }) readonly inAccountableAccountName: string;
    @Prop({ default: "" }) readonly inThirdPartyCompanyId: string;
    @Prop({ default: "" }) readonly inThirdPartyUserId: string;
    @Prop({ default: "" }) readonly inThirdPartyName: string;
    @Prop({ default: null }) inAccountingTransactions: Array<any>;

    @Prop({ default: false }) readonly forCustomer: boolean;

    @Prop({ default: "" }) readonly inInvoiceNumber: string;
    @Prop() accountingLines!: Array<any>;

    @Model() value: boolean;

    step = "personalisedAmounts";

    payDialog = false;

    documentDefaultMailerInfos: any = {
        mailType: "",
        defaultSubject: "",
        defaultText: "",
        withAttachement: true,
    };

    listDocumentsForMail;
    addBudgetInsightUrlForMail: boolean = false;

    payIsActivated: boolean = true;

    validLoading: boolean = false;

    refreshKey = 0;

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    // get companyId() {
    //     return this.$store?.state?.user?.company.id
    // }

    get enableSendMail() {
        if (!this.containsIdenticalKey) {
            return false;
        }
        return this.thirdPartyType === "CLIENT" || this.thirdPartyType === "SUPPLIER";
    }

    get mailTitle() {
        if (this.thirdPartyType === "CLIENT") {
            return "Relancer votre client";
        }
        if (this.thirdPartyType === "SUPPLIER") {
            return "Demander un report à votre fournisseur";
        }
        if (this.thirdPartyType === "USER") {
            return "Demander un report à votre collaborateur";
        }
        return "Envoyer un mail";
    }

    accountingTransactions = [];

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Apollo({
        query: GET_PAYMENT_LINKS,
        variables() {
            return {
                companyId: this.companyId,
                // accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            return !this.companyId || !this.isForClients;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.getPaymentLinks?.paymentLinks?.length) {
                    this.paymentLinks = data.getPaymentLinks.paymentLinks;
                    this.areAccountingTransactionsAlreadyUsedInPaymentLinks(
                        this.accountingTransactions,
                    );
                } else {
                    this.paymentLinks = [];
                }
            }
        },
    })
    paymentLinks = [];

    associatedPaymentLinks = [];

    areAccountingTransactionsAlreadyUsedInPaymentLinks(accountingTransactions) {
        this.associatedPaymentLinks = [];
        debugger;
        if (this.paymentLinks?.length) {
            for (const paymentLink of this.paymentLinks) {
                if (paymentLink.data?.accountingLines?.length) {
                    const usedAccountingLines = paymentLink.data.accountingLines;
                    for (const usedAccLine of usedAccountingLines) {
                        const usedAccTransaction = accountingTransactions.find(
                            (aT) => aT.accountingLineId === usedAccLine.id,
                        );
                        if (usedAccTransaction) {
                            usedAccTransaction.associatedPaymentLink = paymentLink;
                            if (!this.associatedPaymentLinks.includes(paymentLink)) {
                                this.associatedPaymentLinks.push(paymentLink);
                            }
                        }
                    }
                }
            }
        }
        this.refreshKey++;
    }

    computeAccountingTransactions() {
        if (this.inAccountingTransactions) {
            this.accountingTransactions = this.inAccountingTransactions;
            return;
        }

        if (this.accountingLines?.length) {
            const ats = [];
            for (const al of this.accountingLines) {
                const at = JSON.parse(JSON.stringify(al));

                (at.stillOwe = al.amountSigned), (at.personalisedAmountSigned = al.amountSigned);
                at.debit = al.amountSigned > 0 ? al.amountSigned : 0;
                at.credit = al.amountSigned < 0 ? al.amountSigned : 0;

                ats.push(at);
            }
            this.accountingTransactions = ats;
            return;
        }

        debugger; // git-ignore
        this.accountingTransactions = [];
    }

    get thirdPartyCompanyId() {
        if (this.inThirdPartyCompanyId) return this.inThirdPartyCompanyId;

        if (this.accountingLines?.length) {
            const al = this.accountingLines[0];
            if (al.thirdPartyCompany) {
                return al.thirdPartyCompany.id;
            }
        }

        return "";
    }

    get thirdPartyUserId() {
        if (this.inThirdPartyUserId) return this.inThirdPartyUserId;

        if (this.accountingLines?.length) {
            const al = this.accountingLines[0];
            if (al.user) {
                return al.user.id;
            }
        }

        // debugger // git-ignore
        return "";
    }

    get thirdPartyName() {
        if (this.inThirdPartyName) return this.inThirdPartyName;

        if (this.accountingLines?.length) {
            const al = this.accountingLines[0];
            if (al.thirdPartyCompany) {
                return al.thirdPartyCompany.name;
            }
            if (al.user) {
                return getUserDisplayName(al.user);
            }
            if (al.bankAccount) {
                debugger; // git-ignore
                return al.bankAccount.name;
            }
        }

        debugger; // git-ignore
        return "";
    }

    get accountableAccountName() {
        if (this.inAccountableAccountName) return this.inAccountableAccountName;

        if (this.accountingLines?.length) {
            const al = this.accountingLines[0];
            if (al.accountableAccount) {
                return al.accountableAccount.name;
            }
        }

        debugger; // git-ignore
        return "";
    }

    get mailDescription() {
        if (this.thirdPartyType === "CLIENT") {
            return "Relancer votre client pour être payé par mail";
        }
        if (this.thirdPartyType === "SUPPLIER") {
            return "Demander un report de paiement à votre fournisseur par mail";
        }
        if (this.thirdPartyType === "USER") {
            return "Demander un report paiement à votre collaborateur";
        }
    }

    get headers() {
        const result = [
            { text: "Documents", value: "name", sortable: false, align: "left" },
            { text: "Montant", value: "amountSigned", sortable: false, align: "right" },
        ];
        // // if(this.atLeastOneStillOwe) {
        // //     result.push( { text: "Restant dû estimé", value: "amountSigned", sortable: false,  align: "right" })
        // // }
        // result.push( { text: "Montant Personnalisé", value: "personalisedAmountSigned", sortable: false,  align: "center" } )
        return result;
    }

    get headers2() {
        return [
            // { text: "Documents", value: "name", sortable: false,  align: "left" },
            { text: "Liens de paiements", value: "label", sortable: false, align: "left" },
            { text: "Date", value: "createdAt", sortable: false, align: "left" },
            { text: "Montant", value: "amountSigned", sortable: false, align: "right" },
        ];
    }

    get formIsValid() {
        for (const at of this.accountingTransactions) {
            if (!this.isInRange(at)) {
                return false;
            }
        }
        return true;
    }

    formatedDate(createdDate) {
        return moment(createdDate).format("DD/MM/YYYY");
    }

    getInvoiceNumber(item) {
        if (item.invoiceNumber) {
            return item.invoiceNumber;
        }
        if (this.inInvoiceNumber) {
            return this.inInvoiceNumber;
        }
        return "";
    }

    isInRange(accountingLine) {
        if (accountingLine.amountSigned === 0) {
            return false;
        }
        if (accountingLine.amountSigned > 0) {
            if (
                accountingLine.personalisedAmountSigned > 0 &&
                accountingLine.personalisedAmountSigned <= accountingLine.stillOwe
            ) {
                return true;
            }
            return false;
        }
        if (
            accountingLine.personalisedAmountSigned < 0 &&
            accountingLine.personalisedAmountSigned >= accountingLine.stillOwe
        ) {
            return true;
        }
        return false;
    }

    get total() {
        let total = 0;
        for (const al of this.accountingTransactions) {
            if (al.personalisedAmountSigned) {
                total += al.personalisedAmountSigned;
            }
            //  else if (al.amountSigned) {
            //     result += al.amountSigned
            // } else {
            //     if(al.debit) {
            //         result += al.debit
            //         // resultNotPersonalised += doc.debit
            //     }
            //     if(al.credit) {
            //         result -= al.credit
            //         // resultNotPersonalised -= doc.credit
            //     }
            // }
        }
        return total;
    }

    // get totalStillOwe() {
    //     // let result = 0
    //     let total = 0
    //     for(const accountingLine of this.accountingTransactions) {
    //         if(accountingLine.stillOwe) {
    //             total += accountingLine.stillOwe
    //         }
    //     }
    //     return total
    // }

    get actionAccountingLines() {
        const accountingLines = [];
        if (this.paymentLinks?.length && this.isForClients) {
            this.areAccountingTransactionsAlreadyUsedInPaymentLinks(this.accountingTransactions);
        }
        for (const at of this.accountingTransactions) {
            accountingLines.push({
                id: at.accountingLineId || at.id,
                amountSigned: at.amountSigned,
                stillOwe: at.stillOwe,
                personalisedAmountSigned: at.personalisedAmountSigned,
                associatedPaymentLink: at.associatedPaymentLink,
            });
        }
        return accountingLines;
    }

    get sepaTransactions() {
        const transactions = [];
        if (this.accountingLines?.length) {
            for (const al of this.accountingLines) {
                transactions.push({
                    id: al.id,
                    wording: al.wording,
                    // invoiceNumber: iat.invoiceNumber,
                    accountableAccountName: al.accountableAccount?.name || "",
                    userId: al.user?.id || undefined,
                    thirdPartyCompanyId: al.thirdPartyCompany?.id || undefined,
                    amountSigned: al.amountSigned,
                });
            }
        }

        if (this.inAccountingTransactions?.length) {
            for (const iat of this.inAccountingTransactions) {
                transactions.push({
                    id: iat.accountingLineId || iat.id,
                    wording: iat.wording,
                    invoiceNumber: iat.invoiceNumber,
                    accountableAccountName: this.accountableAccountName,
                    userId: this.thirdPartyUserId,
                    thirdPartyCompanyId: this.thirdPartyCompanyId,
                    amountSigned: iat.amountSigned,
                });
            }
        }

        if (this.isForClients) {
            if (this.actionAccountingLines?.length) {
                for (const accLine of this.actionAccountingLines) {
                    const transaction = transactions.find((e) => e.id === accLine.id);
                    if (transaction && accLine.associatedPaymentLink) {
                        transaction.associatedPaymentLink = accLine.associatedPaymentLink;
                    }
                }
            }
        }

        return transactions;
    }

    get enableSepaTransfer() {
        for (const transaction of this.sepaTransactions) {
            let accountableAccountName;
            if (transaction.accountableAccountName) {
                accountableAccountName = transaction.accountableAccountName;
            } else if (transaction.accountableAccount?.name) {
                accountableAccountName = transaction.accountableAccount.name;
            } else {
                debugger;
                return false;
            }
            if (!accountableAccountName) {
                return false;
            }
            if (
                accountableAccountName.startsWith("421") ||
                accountableAccountName.startsWith("425") ||
                accountableAccountName.startsWith("455") ||
                accountableAccountName.startsWith("467")
            ) {
                if (!transaction.userId) {
                    return false;
                }
            } else if (accountableAccountName.startsWith("401")) {
                if (!transaction.thirdPartyCompanyId) {
                    return false;
                }
            } else {
                return false;
            }
        }

        return this.total < 0;
    }

    get enableSepaDirectDebit() {
        for (const transaction of this.sepaTransactions) {
            let accountableAccountName;
            if (transaction.accountableAccountName) {
                accountableAccountName = transaction.accountableAccountName;
            } else if (transaction.accountableAccount?.name) {
                accountableAccountName = transaction.accountableAccount.name;
            } else {
                debugger;
                return false;
            }
            if (!accountableAccountName) {
                return false;
            }
            if (accountableAccountName?.startsWith("411")) {
                if (!transaction.thirdPartyCompanyId) {
                    return false;
                }
            } else {
                return false;
            }
        }

        return this.total > 0;
    }

    get thirdPartyType() {
        if (!this.accountableAccountName) {
            debugger; // git-ignore
            return "XXX";
        }
        if (this.accountableAccountName.startsWith("411")) {
            return "CLIENT";
        } else if (this.accountableAccountName.startsWith("401")) {
            return "SUPPLIER";
        } else if (
            this.accountableAccountName.startsWith("421") ||
            this.accountableAccountName.startsWith("425") ||
            this.accountableAccountName.startsWith("467")
        ) {
            return "USER";
        }
        debugger; // git-ignore
        return "XXX";
    }

    // get atLeastOneStillOwe() {
    //     for(const at of this.accountingTransactions) {
    //         if(at.stillOwe) {
    //             return true
    //         }
    //     }
    //     return false
    // }

    // get totalNul() {
    //     if(!this.total) {
    //         return true
    //     }
    //     return false
    // }

    get disableSendPaiement() {
        if (this.total < 0) {
            return false;
        }
        return true;
    }

    get height() {
        return "min(" + 100 * (this.associatedPaymentLinks.length + 1) + "px, 60vh)";
    }

    beforeMount() {
        // this.computeDocuments()
        this.computeAccountingTransactions();
        if (this.isForClients) {
            this.areAccountingTransactionsAlreadyUsedInPaymentLinks(this.accountingTransactions);
        }
    }

    stayInRange(item) {
        if (item.personalisedAmountSigned < 0) {
            if (item.amountSigned > 0) {
                item.personalisedAmountSigned = 0;
                return;
            }
            if (item.personalisedAmountSigned < item.amountSigned) {
                item.personalisedAmountSigned = item.amountSigned;
                return;
            }
        }
        if (item.personalisedAmountSigned > 0) {
            if (item.amountSigned < 0) {
                item.personalisedAmountSigned = 0;
                return;
            }
            if (item.personalisedAmountSigned > item.amountSigned) {
                item.personalisedAmountSigned = item.amountSigned;
                return;
            }
        }
    }

    nextStep() {
        if (this.step === "splitPayment") {
            this.validateSplitPayment();
            return;
        }
        if (this.step === "personalisedAmounts" && this.associatedPaymentLinks?.length) {
            this.step = "warnAccLinesAlreadyUsedInPaymLinks";
            return;
        }
        this.step = "chooseOperation";
    }
    previousStep() {
        if (this.step === "chooseOperation" && this.associatedPaymentLinks?.length) {
            this.step = "warnAccLinesAlreadyUsedInPaymLinks";
        } else if (
            this.step === "chooseOperation" ||
            this.step === "warnAccLinesAlreadyUsedInPaymLinks"
        ) {
            this.step = "personalisedAmounts";
        } else {
            this.step = "chooseOperation";
        }
    }

    close() {}

    cashPayment() {
        this.step = "cashPayment";
    }

    chequePayment() {
        this.step = "chequePayment";
    }

    goToPayStep() {
        if (this.payIsActivated) {
            this.step = "pay";
        }
    }

    //
    get validTitle() {
        return this.step === "splitPayment" ? "Valider" : "Suivant";
    }
    get validDisabled() {
        if (this.step === "splitPayment") {
            return this.splitPaymentValidDisabled;
        }
        return !this.formIsValid;
    }

    /// action management

    chequePaymentActions = {
        action: new DialogAction(),
    };

    cashPaymentActions = {
        action: new DialogAction(),
    };

    payActions = {
        action: new DialogAction(),
    };

    sepaActions = {
        action: new DialogAction(),
    };

    get actions() {
        if (this.step === "chequePayment") {
            return this.chequePaymentActions;
        }
        if (this.step === "cashPayment") {
            return this.cashPaymentActions;
        }
        if (this.step === "pay") {
            return this.payActions;
        }
        if (this.step === "sepa") {
            return this.sepaActions;
        }
        return null;
    }

    onActionDone() {
        this.dialog = false;
        this.$emit("actionDone");
    }

    //
    // mailer dialog
    //
    async getDefaultMailer() {
        const result = await this.$apollo.query({
            query: GET_DEFAULT_MAILER,
            fetchPolicy: "network-only",
            variables: {
                total: this.total,
                isForClients: this.isForClients,
                reminder: true,
                listDocuments: this.accountingTransactions,
                userId: this.$store.state.user.id,
                displayBudgetInsightURL: this.addBudgetInsightUrlForMail,
                companyId: this.companyId,
            },
        });
        this.documentDefaultMailerInfos = result.data.getDefaultMailer;
        this.mailerDialog = true;
    }

    budgetInsightOptions = null;

    mailerDialogWithBudgetInsight(value_from_child) {
        this.budgetInsightOptions = value_from_child;
        this.budgetInsightOptions.frontUrlSuffix = this.$route.fullPath;
        this.getDefaultMailer();
    }

    mailerDialog = false;

    sendMail() {
        if (this.thirdPartyType === "CLIENT") {
            this.step = "paymentLink";
        } else {
            this.addBudgetInsightUrlForMail = false;
            this.getDefaultMailer();
        }
        //this.$emit('sendMailFromPaymentManagement', { accountingTransactions: this.accountingTransactions, total: this.total })
    }

    get isForClients() {
        if (this.accountableAccountName === "411000") {
            return true;
        }
        return false;
    }

    //
    // split payment
    //
    splittedPayments = [];

    get splitHeaders() {
        const result = [
            { text: "Documents", value: "name", sortable: false, align: "left" },
            { text: "Montant", value: "amountSigned", sortable: false, align: "right" },
            { text: "Date d'échéhance", value: "dueDate", sortable: false, align: "center" },
            { text: "Action", value: "action", sortable: false, align: "center" },
        ];
        // // if(this.atLeastOneStillOwe) {
        // //     result.push( { text: "Restant dû estimé", value: "amountSigned", sortable: false,  align: "right" })
        // // }
        // result.push( { text: "Montant Personnalisé", value: "personalisedAmountSigned", sortable: false,  align: "center" } )
        return result;
    }

    get enableSplitPayment() {
        if (!this.containsIdenticalKey) {
            return false;
        }
        if (this.accountableAccountName === "401000") {
            return true;
        }
        return false;
    }

    get splitPaymentValidDisabled() {
        if (this.total - this.splittedTotal) return true;
        const used = {};
        let identicalCount = 0;
        for (const sp of this.splittedPayments) {
            if (!sp.amountSigned) {
                return true;
            }
            for (const at of this.accountingTransactions) {
                const id = at.accountingLineId || at.id;
                if (used[id]) {
                    continue;
                }
                if (at.amountSigned === sp.amountSigned) {
                    identicalCount++;
                    used[id] = true;
                }
            }
        }
        return identicalCount === this.accountingTransactions.length;
    }

    goToSplitPayment() {
        if (!this.splittedPayments.length) {
            const splittedPayments = _.cloneDeep(this.accountingTransactions);
            for (const sp of splittedPayments) {
                if (sp.dueDate === undefined || sp.dueDate === null) {
                    sp.dueDate = "";
                }
            }
            if (splittedPayments.length === 1) {
                splittedPayments.push({
                    wording: "",
                    amountSigned: 0.0,
                    dueDate: "",
                });
            }
            this.splittedPayments = splittedPayments;
        }
        this.step = "splitPayment";
    }

    get splittedTotal() {
        let total = 0;
        for (const al of this.splittedPayments) {
            if (al.amountSigned) {
                total += al.amountSigned;
            }
        }
        return total;
    }

    async validateSplitPayment() {
        this.validLoading = true;

        await this.$apollo.mutate({
            mutation: SPLIT_PAYMENT,
            variables: {
                accountingLineIds: this.accountingTransactions.map(
                    (at) => at.accountingLineId || at.id,
                ),
                amounts: this.splittedPayments.map((sp) => ({
                    amountSigned: sp.amountSigned,
                    dueDate: sp.dueDate,
                })),
            },
        });
        this.validLoading = false;
        this.onActionDone();
        this.close();
    }

    addSplitPayment() {
        const prevItem = this.splittedPayments.length
            ? this.splittedPayments[this.splittedPayments.length - 1]
            : undefined;
        this.splittedPayments.push({
            wording: prevItem?.wording || "",
            invoiceNumber: prevItem?.invoiceNumber || "",
            amountSigned: 0,
        });
    }

    removeSplitPayment(splitPayment) {
        const index = this.splittedPayments.findIndex((sp) => sp === splitPayment);
        if (index !== -1) {
            this.splittedPayments.splice(index, 1);
        }
    }

    openMailerDialogWithURL() {
        this.addBudgetInsightUrlForMail = true;
        this.step = "pay";
    }

    checkNotAlreadyExistsAndOpenMailerDialogWithoutCredits() {
        //? temporary
        this.validLoading = true;
        const alreadyUsedAccAccounts = this.checkAccLinesNotAlreadyUsedInOtherPaymentLink();
        this.validLoading = false;
        if (alreadyUsedAccAccounts && alreadyUsedAccAccounts.length === 0) {
            this.addBudgetInsightUrlForMail = true;
            this.step = "pay";
        } else {
            // display window item with errors + tooltip how delete links
        }
    }

    checkAccLinesNotAlreadyUsedInOtherPaymentLink() {
        //? temporary
        return [];
    }

    get containsIdenticalKey() {
        let key = "";
        if (this.accountingLines?.length) {
            for (const al of this.accountingLines) {
                if (!key) key = al.key;
                else if (key !== al.key) {
                    return false;
                }
            }
        } else if (this.inAccountingTransactions.length) {
            return true;
        } else {
            debugger;
        }
        return true;
    }
}

export default toNative(PaymentManagement);
</script>
